jQuery(document).ready(function () {
  sliders();
});
function sliders() {
  var swiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      //stopOnLastSlide: false,
      //disableOnInteraction: true,
    },
    pagination: {
      el: '.testimonial-swiper .swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.testimonial-swiper .swiper-button-next',
      prevEl: '.testimonial-swiper .swiper-button-prev',
    },
    breakpoints: {
      556: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },

      1560: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });

  var swiper2 = new Swiper('.testimonial-swiper-2', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    spaceBetween: -177,
    slidesPerView: 2,
    coverflowEffect: {
      rotate: 0,
      stretch: -25,
      depth: 644,
      modifier: 2,
    },
    loop: true,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.testimonial-swiper-2 .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    navigation: {
      nextEl: '.testimonial-swiper-2 .swiper-button-next',
      prevEl: '.testimonial-swiper-2 .swiper-button-prev',
    },

    breakpoints: {
      768: {
        spaceBetween: -81,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 18,
          depth: 164,
          modifier: 3,
        },
      },
    },
  });
  if (jQuery('.best-sellers').length > 0) {
    var number = 30;
    var swipers = {};
    var swipers2 = {};
    jQuery('.best-sellers .content-box .items-block').each(function () {
      var currentClassSuffix = number;
      jQuery(this)
        .children('.sellers-text-swiper')
        .addClass('sellers-text-swiper' + number);
      jQuery(this)
        .children('.sellers-swiper')
        .addClass('sellers-swiper' + number);
      number++;

      setTimeout(function () {
        swipers['swiper' + currentClassSuffix] = new Swiper(
          '.sellers-text-swiper' + currentClassSuffix,
          {
            effect: 'fade',
            loop: true,
            allowTouchMove: false,
            pagination: {
              el: '.swiper-pagination',
              type: 'progressbar',
              clickable: true,
            },
          }
        );

        swipers2['swiper' + currentClassSuffix] = new Swiper(
          '.sellers-swiper' + currentClassSuffix,
          {
            slidesPerView: 1,
            loop: true,
            //centeredSlides: true,
            autoplay: {
              delay: 6000,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            thumbs: {
              swiper: swipers['swiper' + currentClassSuffix],
            },
            breakpoints: {
              768: {
                slidesPerView: 3,
              },
            },
          }
        );
      }, 300);
    });
  }

  var swiper4 = new Swiper('.product-swiper-2', {
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.product-swiper-2 .swiper-button-next',
      prevEl: '.product-swiper-2 .swiper-button-prev',
    },
    pagination: {
      el: '.product-swiper-2 .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    autoplay: {
      delay: 6000,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      1024: {
        slidesPerView: 4,
        centeredSlides: false,
      },

      1560: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });

  var swiper42 = new Swiper('.product-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.product-swiper .swiper-button-next',
      prevEl: '.product-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.product-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    autoplay: {
      delay: 6000,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      1024: {
        slidesPerView: 4,
        centeredSlides: false,
      },

      1560: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });

  var swiper6 = new Swiper('.product-swiper-small', {
    slidesPerView: 5,
    freeMode: true,
    loop: true,
    grabCursor: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.product-swiper-small .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-swiper-small .swiper-button-next',
      prevEl: '.product-swiper-small .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 7,
      },
      1200: {
        slidesPerView: 10,
      },
    },
  });
  var swiper5 = new Swiper('.product-swiper-big', {
    loop: true,
    autoplay: {
      delay: 6000,
    },
    navigation: {
      nextEl: '.product-swiper-big .swiper-button-next',
      prevEl: '.product-swiper-big .swiper-button-prev',
    },
    thumbs: {
      swiper: swiper6,
    },
  });

  var swiper7 = new Swiper('.bundle-item-swiper', {
    centeredSlides: true,
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.bundle-item-swiper .swiper-button-next',
      prevEl: '.bundle-item-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.bundle-item-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
  });

  var swiperCartRecommended = new Swiper('.cart-recommended-item-swiper', {
    centeredSlides: true,
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.cart-recommended-item-swiper .swiper-button-next',
      prevEl: '.cart-recommended-item-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.cart-recommended-item-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
  });

  var swiper8 = new Swiper('.product-gallery-swiper', {
    slidesPerView: 'auto',
    //centeredSlides: true,
    grabCursor: true,

    slideToClickedSlide: true,
    navigation: {
      nextEl: '.product-gallery-swiper .swiper-button-next',
      prevEl: '.product-gallery-swiper .swiper-button-prev',
    },
    breakpoints: {
      556: {
        slidesPerView: 'auto',
        centeredSlides: true,
      },
      1024: {
        slidesPerView: 'auto',
        centeredSlides: true,
      },
    },
  });

  if (jQuery(window).width() < 556) {
    var swiper9 = new Swiper('.product-gallery-swiper-mobile', {
      slidesPerView: 1,
      //loop: true,
      effect: 'fade',
      navigation: {
        nextEl: '.product-gallery-swiper-mobile .swiper-button-next',
        prevEl: '.product-gallery-swiper-mobile .swiper-button-prev',
      },
      thumbs: {
        swiper: swiper8,
      },
    });
  } else {
    var swiper9 = new Swiper('.product-gallery-swiper-mobile', {
      slidesPerView: 1,
      //loop: true,
      effect: 'fade',
      navigation: {
        nextEl: '.product-gallery-swiper-mobile .swiper-button-next',
        prevEl: '.product-gallery-swiper-mobile .swiper-button-prev',
      },
    });
  }

  var swiper10 = new Swiper('.product-comparison-swiper', {
    slidesPerView: 1,
    pagination: {
      el: '.product-comparison-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      556: {
        slidesPerView: 2,
      },

      992: {
        slidesPerView: 3,
      },
    },
  });

  var swiper11 = new Swiper('.plp-banner-links', {
    slidesPerView: 'auto',
    pagination: {
      el: '.plp-banner-links .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
  });

  var swiper12 = new Swiper('.plp-best-sellers-swiper', {
    slidesPerView: 1,
    pagination: {
      el: '.plp-best-sellers-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      556: {
        slidesPerView: 2,
      },

      992: {
        slidesPerView: 3,
      },
    },
  });
  var swiper13 = new Swiper('.pcp-tab-swiper', {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.pcp-tab-swiper .swiper-button-next',
      prevEl: '.pcp-tab-swiper .swiper-button-prev',
    },
  });
  jQuery('.pcp-tab-row .tab-row .tab-item a').click(function (event) {
    event.preventDefault();
    var this_c = jQuery(this);
    var index_c = this_c.parents('.tab-item').index();
    swiper13.slideTo(index_c);

    jQuery('.pcp-tab-popup').addClass('is-show');
    setTimeout(function () {
      jQuery('.pcp-tab-popup').addClass('is-show-2');
    }, 300);
    setTimeout(function () {
      jQuery('.pcp-tab-popup').addClass('is-show-3');
    }, 700);
  });

  var swiper14 = new Swiper('.guides-cards', {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.guides-cards .swiper-pagination',
      type: 'progressbar',
    },

    breakpoints: {
      556: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      992: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });

  var swiper15 = new Swiper('.about-sleep-swiper', {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.about-sleep-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    navigation: {
      nextEl: '.about-sleep-swiper .swiper-button-next',
      prevEl: '.about-sleep-swiper .swiper-button-prev',
    },

    breakpoints: {
      768: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        spaceBetween: 36,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: -18,
          depth: 164,
          modifier: 3,
        },
      },
    },
  });

  var swiper16 = new Swiper('.blog-authors-cards-swiper', {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.blog-authors .swiper-pagination',
      type: 'progressbar',
    },
    breakpoints: {
      556: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },

      992: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });

  var swiper17 = new Swiper('.about-sleep-stories-swiper', {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.about-sleep-stories-swiper .swiper-button-next',
      prevEl: '.about-sleep-stories-swiper .swiper-button-prev',
    },
  });
  jQuery('.about-sleep-stories .about-sleep-swiper .swiper-slide .card-text .btn-more').click(
    function (event) {
      event.preventDefault();
      var this_c = jQuery(this);
      var index_c = this_c.attr('data-number');
      swiper17.slideTo(index_c);

      jQuery('.about-sleep-stories-popup').addClass('is-show');
      setTimeout(function () {
        jQuery('.about-sleep-stories-popup').addClass('is-show-2');
      }, 300);
      setTimeout(function () {
        jQuery('.about-sleep-stories-popup').addClass('is-show-3');
      }, 700);
    }
  );
}
